import { TextField, styled } from '@mui/material';

export const StyledColorPickerWrap = styled('div')({
	'& .react-colorful': {
		gap: '16px',
		width: 'min(100%, 300px)',
		height: '245px',
	},
	'& .react-colorful__saturation': {
		borderRadius: '8px',
		width: '100%',
	},
	'& .react-colorful__hue': {
		borderRadius: '24px',
		height: '12px',
		width: '100%',
	},
	'& .react-colorful__pointer': {
		width: '24px',
		height: '24px',
		border: '6px solid #fff',
	},
});

export const StyledColorPickerColorWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	borderRadius: '8px',
	padding: '4px',
	marginTop: '16px',
	cursor: 'pointer',
});

export const StyledColorPickerColorBox = styled('div')({
	width: '40px',
	height: '40px',
	borderRadius: '8px',
});

export const StyledColorPickerColorInput = styled(TextField)({
	borderRadius: '8px',
	'& .MuiInputBase-root': {
		background: 'none',
	},
});
